import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { FiFileText, FiShoppingCart } from "react-icons/fi";
import { FaChartLine, FaUser, FaUsersCog } from "react-icons/fa";
import { GrVmMaintenance } from "react-icons/gr";
import { BsInfoSquare } from "react-icons/bs";
import { BiBuildings, BiShield } from "react-icons/bi";
import { IoGrid } from "react-icons/io5";
import { PiListChecks } from "react-icons/pi";
import { BsDatabaseCheck } from "react-icons/bs";
import { LuFileClock } from "react-icons/lu";
import PERMISSIONS_ENUM from "../enums/permissions";

export const DASHBOARD_SIDEBAR_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "projects",
    label: "Projects",
    path: "/dashboard/project",
    icon: <DescriptionOutlinedIcon style={{ width: 18, height: 18 }} />,
    permission: PERMISSIONS_ENUM.PROJECT_VIEW,
  },
  {
    key: "reports",
    label: "Reports",
    path: "/dashboard/reports",
    icon: <PictureAsPdfOutlinedIcon style={{ width: 18, height: 18 }} />,
    permission: PERMISSIONS_ENUM.REPORT_VIEW,
  },
  {
    key: "user-management",
    label: "User Management",
    icon: <FaUsersCog />,
    type: "accordion",
    permission: PERMISSIONS_ENUM.USER_VIEW,
    sublinks: [
      {
        key: "roles-in-system",
        label: "Roles In the system",
        path: "/dashboard/roles",
        icon: <BiShield />,
      },
      {
        key: "users",
        label: "Users",
        path: "/dashboard/user-management",
        icon: <FaUser />,
      },
    ],
  },
];

export const CUSTOMER_PROPERTY_NAVIGATION = [
  {
    key: "information",
    label: "Information",
    path: "/dashboard/building/information",
    icon: <BsInfoSquare />,
  },
  {
    key: "custProperty",
    label: "Building",
    path: "/dashboard/buildings/overview",
    icon: <BiBuildings />,
    children: [
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image1",
      },
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image2",
      },
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image3",
      },
    ],
  },
  {
    key: "financial-overview",
    label: "Financial Overview",
    path: "/dashboard/building/finance",
    icon: <FaChartLine />,
  },
  {
    key: "maintenance",
    label: "Maintenance",
    path: "/dashboard/building/maintainence",
    icon: <GrVmMaintenance />,
  },
];
export const CUSTOMER_PROPERTY_NAVIGATION_FACADE = [
  {
    key: "information",
    label: "Information",
    path: "/dashboard/building/information",
    icon: <BsInfoSquare />,
  },
  {
    key: "custProperty",
    label: "Building",
    path: "/dashboard/buildings/overview",
    icon: <BiBuildings />,
    children: [
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image1",
      },
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image2",
      },
      {
        key: "custImages",
        label: "Images",
        path: "/dashboard/building/image3",
      },
    ],
  },
  // {
  //   key: "financial-overview",
  //   label: "Financial Overview",
  //   path: "/dashboard/building/finance",
  //   icon: <FaChartLine />,
  // },
  // {
  //   key: "maintenance",
  //   label: "Maintenance",
  //   path: "/dashboard/building/maintainence",
  //   icon: <GrVmMaintenance />,
  // },
];
export const DASHBOARD_SIDEBAR_CLIENT_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid style={{ width: 15, height: 15 }} />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "assets",
    label: "Assets",
    path: "/dashboard/projects",
    icon: <DescriptionOutlinedIcon style={{ width: 18, height: 18 }} />,
    permission: PERMISSIONS_ENUM.PROJECT_VIEW,
  },
  {
    key: "document",
    label: "Document",
    path: "/dashboard/document",
    icon: <FiFileText />,
    permission: PERMISSIONS_ENUM.DATA_EXPORT,
  },
  {
    key: "damage-management",
    label: "Damage Management",
    path: "/dashboard/damage-management",
    icon: <LuFileClock />,
    permission: PERMISSIONS_ENUM.DAMAGE_VIEW,
  },
  {
    key: "managebids",
    label: "Manage Bids",
    path: "/dashboard/managebids",
    icon: <PiListChecks />,
    permission: PERMISSIONS_ENUM.TENDER_VIEW,
  },
  {
    key: "user-management",
    label: "User Management",
    icon: <FaUsersCog />,
    type: "accordion",
    permission: PERMISSIONS_ENUM.USER_VIEW,
    sublinks: [
      {
        key: "roles-in-system",
        label: "Roles In the system",
        path: "/dashboard/roles",
        icon: <BiShield />,
      },
      {
        key: "users",
        label: "Users",
        path: "/dashboard/user-management",
        icon: <FaUser />,
      },
    ],
  },
];
export const DASHBOARD_SIDEBAR_CLIENT_MEMBER_LINKS = DASHBOARD_SIDEBAR_CLIENT_LINKS.filter(
  (link) => link.key !== "user-management",
);
export const DASHBOARD_SIDEBAR_CONTACT_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "document",
    label: "Document",
    path: "/dashboard/document",
    icon: <FiFileText />,
    permission: PERMISSIONS_ENUM.DATA_EXPORT,
  },
];
export const DASHBOARD_SIDEBAR_CONTRACTOR_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "marketplace",
    label: "Marketplace",
    path: "/dashboard/marketplace",
    icon: <FiShoppingCart />,
    permission: PERMISSIONS_ENUM.MARKETPLACE_VIEW,
  },
  {
    key: "managetenders",
    label: "Manage Tenders",
    path: "/dashboard/manage-tender",
    icon: <BsDatabaseCheck />,
    permission: PERMISSIONS_ENUM.TENDER_VIEW,
  },
  {
    key: "user-management",
    label: "User Management",
    icon: <FaUsersCog />,
    type: "accordion",
    permission: PERMISSIONS_ENUM.USER_VIEW,
    sublinks: [
      {
        key: "roles-in-system",
        label: "Roles In the system",
        path: "/dashboard/roles",
        icon: <BiShield />,
      },
      {
        key: "users",
        label: "Users",
        path: "/dashboard/user-management",
        icon: <FaUser />,
      },
    ],
  },
];

export const DASHBOARD_SIDEBAR_PROJECT_MANAGER_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "managetenders",
    label: "Manage Tenders",
    path: "/dashboard/manage-tender",
    icon: <BsDatabaseCheck />,
    permission: PERMISSIONS_ENUM.TENDER_VIEW,
  },
  {
    key: "user-management",
    label: "User Management",
    icon: <FaUsersCog />,
    type: "accordion",
    permission: PERMISSIONS_ENUM.USER_VIEW,
    sublinks: [
      {
        key: "roles-in-system",
        label: "Roles In the system",
        path: "/dashboard/roles",
        icon: <BiShield />,
      },
      {
        key: "users",
        label: "Users",
        path: "/dashboard/user-management",
        icon: <FaUser />,
      },
    ],
  },
];
export const DASHBOARD_SIDEBAR_PROJECT_WORKER_LINKS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard/",
    icon: <IoGrid />,
    permission: PERMISSIONS_ENUM.DASHBOARD_VIEW,
  },
  {
    key: "managetenders",
    label: "Manage Tenders",
    path: "/dashboard/manage-tender",
    icon: <BsDatabaseCheck />,
    permission: PERMISSIONS_ENUM.TENDER_VIEW,
  },
];
